export default {
    namespaced: true,
    state() {
        return {
            miniUserId: localStorage.getItem("MINI_USER_ID"),
            miniUserLocation: localStorage.getItem("MINI_USER_LOCATION"),
            miniUserLocationPoint: localStorage.getItem("MINI_USER_LOCATION_POINT"),
            // 搜索状态，false：未搜索，true：搜索中（宽度变化）
            searchStatus: false,
            dropdownGardenItem: {},
            fruitsTypeId: "",
            fruitsTypeItemId: "",
            periodId: "",
            explainData: {},
            clickPoint: [],
            isShowExplain: false,
            tabBarHeight: 50,
            fruitsData: [],
            updateGardenList: false,
            gardenId: localStorage.getItem('selectedFarmId') || '',
            temporarilyForm: {}, //添加、编辑农场存放form临时数据
            polygonData: null,
            editFarmData: null // 编辑农场时的数据
        }
    },
    getters: {
    },
    mutations: {
        SET_TEMPORARILY_FORM(state, obj) {
            state.temporarilyForm = obj
        },
        SET_MINI_USER_ID(state, miniUserId) {
            let id = localStorage.getItem("MINI_USER_ID")
            state.miniUserId = id
        },
        SET_MINI_USER_LOCATION(state, miniUserLocation) {
            let location = localStorage.getItem("MINI_USER_LOCATION")
            state.miniUserLocation = location
        },
        SET_MINI_USER_LOCATION_POINT(state, miniUserLocationPoint) {
            let locationPoint = localStorage.getItem("MINI_USER_LOCATION_POINT")
            state.miniUserLocationPoint = locationPoint
        },
        SET_GARDEN_ID(state, id) {
            state.gardenId = id;
            localStorage.setItem('selectedFarmId', id);
        },
        SET_UPDATE_GARDEN_LIST(state, val) {
            state.updateGardenList = val;
        },
        SET_FRUITSDATA(state, arr) {
            state.fruitsData = arr;
        },
        SET_SHOW_EXPLAIN(state, value) {
            state.isShowExplain = value;
        },
        SET_DROPDOWN_GARDEN_ITEM(state, value) {
            state.dropdownGardenItem = value;
        },
        SET_SEARCH_STATUS(state, status) {
            state.searchStatus = status
        },
        SET_FRUITS_TYPE_ID(state, id) {
            state.fruitsTypeId = id
        },
        SET_FRUITS_TYPE_ITEM_ID(state, id) {
            state.fruitsTypeItemId = id
        },
        SET_PERIOD_ID(state, id) {
            state.periodId = id
        },
        SET_EXPLAIN_DATA(state, data) {
            state.explainData = data
        },
        SET_CLICK_POINT(state, ponit) {
            state.clickPoint = ponit
        },
        SET_TAB_BAR_HEIGHT(state, height) {
            state.tabBarHeight = height
        },
        // 创建农场勾选范围
        SET_FARM_POLYGON(state, polygonData) {
            state.polygonData = polygonData
        },
        // 设置编辑农场数据
        SET_EDIT_FARM_DATA(state, farmData) {
            state.editFarmData = farmData
        },
    },
    actions: {
        updateDropdownItem({ commit }, value) {
            commit('SET_DROPDOWN_GARDEN_ITEM', value);
        },
    },
};
